module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-statebrowser"
  }, [_c('div', {
    staticClass: "kiwi-statebrowser-tools"
  }, _vm._l((_vm.pluginUiElements), function(el) {
    return _c('div', {
      directives: [{
        name: "rawElement",
        rawName: "v-rawElement",
        value: (el),
        expression: "el"
      }],
      staticClass: "kiwi-statebrowser-tool"
    })
  })), _vm._v(" "), (_vm.bufferForPopup) ? _c('div', {
    staticClass: "kiwi-statebrowser-channel-popup",
    style: ({
      top: _vm.popup_top + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('buffer-settings', {
    attrs: {
      "buffer": _vm.bufferForPopup
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.closeBuffer
    }
  }, [_vm._v(_vm._s(_vm.$t('state_leave', {
    name: _vm.bufferForPopup.name
  })))])], 1) : _vm._e(), _vm._v(" "), (_vm.isPersistingState) ? _c('div', {
    staticClass: "kiwi-statebrowser-usermenu",
    class: [_vm.is_usermenu_open ? 'kiwi-statebrowser-usermenu--open' : '']
  }, [_c('a', {
    staticClass: "kiwi-statebrowser-usermenu-header",
    on: {
      "click": function($event) {
        _vm.is_usermenu_open = !_vm.is_usermenu_open
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('state_account')) + " "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), (_vm.is_usermenu_open) ? _c('div', {
    staticClass: "kiwi-statebrowser-usermenu-body"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('state_remembered'))), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.clickForget
    }
  }, [_vm._v(_vm._s(_vm.$t('state_forget')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": function($event) {
        _vm.is_usermenu_open = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kiwi-statebrowser-divider"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kiwi-statebrowser-switcher"
  }, [(!_vm.isRestrictedServer) ? _c('a', {
    on: {
      "click": _vm.clickAddNetwork
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _c('a', {
    on: {
      "click": _vm.clickAppSettings
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.networks.length === 0) ? _c('div', {
    staticClass: "kiwi-statebrowser-nonetworks"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('state_network'))), _c('br'), _c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.clickAddNetwork
    }
  }, [_vm._v(_vm._s(_vm.$t('state_add')))])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.provided_networks).length > 0) ? _c('div', {
    staticClass: "kiwi-statebrowser-availablenetworks"
  }, [_c('div', {
    staticClass: "kiwi-statebrowser-availablenetworks-toggle",
    on: {
      "click": function($event) {
        _vm.show_provided_networks = !_vm.show_provided_networks
      }
    }
  }, [_vm._v("↪ " + _vm._s(_vm.$t('state_available')))]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-statebrowser-availablenetworks-networks",
    class: {
      'kiwi-statebrowser-availablenetworks-networks--open': _vm.show_provided_networks
    }
  }, _vm._l((_vm.provided_networks), function(pNets, pNetTypeName) {
    return _c('div', {
      staticClass: "kiwi-statebrowser-availablenetworks-type"
    }, [_c('div', {
      staticClass: "kiwi-statebrowser-availablenetworks-name"
    }, [_vm._v(_vm._s(pNetTypeName))]), _vm._v(" "), _vm._l((pNets), function(pNet) {
      return _c('div', {
        staticClass: "kiwi-statebrowser-availablenetworks-link",
        class: [pNet.connected ? 'kiwi-statebrowser-availablenetworks-link--connected' : '']
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.connectProvidedNetwork(pNet)
          }
        }
      }, [_vm._v(_vm._s(pNet.name))]), _c('br')])
    })], 2)
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kiwi-statebrowser-scrollarea"
  }, [_c('div', {
    staticClass: "kiwi-statebrowser-networks"
  }, _vm._l((_vm.networksToShow), function(network) {
    return _c('state-browser-network', {
      attrs: {
        "network": network
      },
      on: {
        "showBufferSettings": _vm.showBufferPopup
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d2900bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StateBrowser.vue
// module id = 494
// module chunks = 2